import {
  NotificationIcon as CoreNotificationIcon,
  useSession,
} from '@zhiyue/core';
import React from 'react';
import { ensureValidAccessToken, hasOAuth2Session } from '@/services/oauth2';

type NotificationIconProps = Omit<
  React.ComponentProps<typeof CoreNotificationIcon>,
  'token' | 'mode'
>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const { currentUser, loading } = useSession();
  const [token, setToken] = React.useState<string>();

  React.useEffect(() => {
    if (loading || !currentUser?.memberUuid || !hasOAuth2Session()) {
      setToken(undefined);
      return;
    }

    let active = true;
    ensureValidAccessToken()
      .then((accessToken) => {
        if (active) {
          setToken(accessToken ?? undefined);
        }
      })
      .catch(() => {
        if (active) {
          setToken(undefined);
        }
      });

    return () => {
      active = false;
    };
  }, [currentUser?.memberUuid, loading]);

  if (loading || !currentUser?.memberUuid || !token) {
    return null;
  }

  return <CoreNotificationIcon {...props} mode="direct" token={token} />;
};

export default NotificationIcon;
